<template>
  <div id="app" class="bg-dark-blue flex py-8 pb-6 pt-6">
    <router-view/>
  </div>
</template>

<script>
import '@/assets/styles/app.scss'
export default {
  mounted() {
    //refresh page every hour just in case
    setInterval(function(){ location.reload(); }, 1000 * 60 * 60);

  }
}
</script>


<style lang="scss">
#app {
  height: 100%;
}


 //lg
@media (max-width: 1279.98px) { 
  #app {
    height: auto;
  }
}

//md
@media (max-width: 1023.98px) {

}

// sm
@media (max-width: 767.98px) { 

}

// xs
@media (max-width: 639.98px) { 

}
</style>
